import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import EditText from '../../../../components/base/edit-text/edit-text';
import Button from '../../../../components/base/button/button';
import i18n from '../../../../translations/strings';
import { ResetPasswordFormStyled } from './reset-password-form.styled';

const ResetPasswordForm = (props: any) => {
  const {
    control,
    formState: { errors },
    register,
    handleSubmit,
  } = useFormContext();

  return (
    <ResetPasswordFormStyled.Container>
        <Controller
            control={control}
            rules={{
                required: true,
            }}
            render={({ field: { onChange, value } }) => (
                <EditText
                    error={errors?.email?.message?.toString()}
                    fullWidth
                    {...register('email')}
                    defaultValue={value}
                    placeholder={i18n.t('common.email')}
                    onChange={onChange}
                    label={i18n.t('common.email')}
                />
            )}
            name="email"
        />
      <ResetPasswordFormStyled.Separator />
      <ResetPasswordFormStyled.ContainerButton>
        <Button
          onClick={handleSubmit(props.onSubmit, props.onError)}
          label={i18n.t('registration.registrationPasswordReset')}
        />
      </ResetPasswordFormStyled.ContainerButton>
    </ResetPasswordFormStyled.Container>
  );
};

export default ResetPasswordForm;
